




























































































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.UserScheduleList;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.UserScheduleList[];

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

type UpdateReq = I.PacketUserScheduleUpdate;

const DataStore = U.DataStore;

class OperCodeType {
  operCode = '1';
  name = '';
}

class ScheduleTable {
  num?: number;
  time = '00:00~00:00';
  sunday = false;
  monday = false;
  tueday = false;
  wedday = false;
  thuday = false;
  friday = false;
  satday = false;
  holiday = false;
  operfunccode = '1';
}

class State {
  zoneCode: number;
  code: number;
  name: string;
  etc: string;
  operCode: string;
  scheduleTable: ScheduleTable[];
  itemStatus: E.ItemStatus;

  constructor() {
    this.zoneCode = '0' as never;
    this.code = '0' as never;
    this.name = '' as never;
    this.etc = '' as never;
    this.operCode = '1' as never;
    this.scheduleTable = Array.from(Array(10)).map(() => new ScheduleTable());
    this.itemStatus = E.ItemStatus.None;
  }
}

interface EditDialogTimeProps {
  time: string;
  initTime: string;
  latestTime: string;

  canceled: boolean;
  saved: boolean;
  valid: boolean;
}

type ValueOfString<T> = { [P in keyof T]: string };

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.config.schedule();
    console.log('page', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: UpdateReq) {
    console.log(item);
    const result = await this.API.call.config.scheduleUpdate(item);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '스케줄 데이터 - 출입문 제어',
      store: new DataStore<ScheduleTable>({
        headers: {
          num: { text: '순번', width: 60, align: 'center', sortable: false },
          time: { text: '적용시간', width: 120, align: 'center' },
          sunday: { text: '일', width: 60, align: 'center' },
          monday: { text: '월', width: 60, align: 'center' },
          tueday: { text: '화', width: 60, align: 'center' },
          wedday: { text: '수', width: 60, align: 'center' },
          thuday: { text: '목', width: 60, align: 'center' },
          friday: { text: '금', width: 60, align: 'center' },
          satday: { text: '토', width: 60, align: 'center' },
          holiday: { text: '휴일', width: 60, align: 'center' }
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }

  get dataHeader() {
    switch (this.dataItem.state.operCode) {
      case '1': // 출입문 제어
        return new DataStore<ScheduleTable>({
          headers: {
            num: { text: '순번', width: 60, align: 'center', sortable: false },
            time: { text: '적용시간', width: 120, align: 'center' },
            sunday: { text: '일', width: 60, align: 'center' },
            monday: { text: '월', width: 60, align: 'center' },
            tueday: { text: '화', width: 60, align: 'center' },
            wedday: { text: '수', width: 60, align: 'center' },
            thuday: { text: '목', width: 60, align: 'center' },
            friday: { text: '금', width: 60, align: 'center' },
            satday: { text: '토', width: 60, align: 'center' },
            holiday: { text: '휴일', width: 60, align: 'center' },
            operfunccode: { text: '제어', width: 60, align: 'center' }
          }
        }).headers;
      case '6': // 아웃풋 제어
        return new DataStore<ScheduleTable>({
          headers: {
            num: { text: '순번', width: 60, align: 'center', sortable: false },
            time: { text: '적용시간', width: 120, align: 'center' },
            sunday: { text: '일', width: 60, align: 'center' },
            monday: { text: '월', width: 60, align: 'center' },
            tueday: { text: '화', width: 60, align: 'center' },
            wedday: { text: '수', width: 60, align: 'center' },
            thuday: { text: '목', width: 60, align: 'center' },
            friday: { text: '금', width: 60, align: 'center' },
            satday: { text: '토', width: 60, align: 'center' },
            holiday: { text: '휴일', width: 60, align: 'center' },
            operfunccode: { text: '제어2', width: 60, align: 'center' }
          }
        }).headers;
      default:
        return this.dataItem.store.headers;
    }
    // return this.dataItems[0].store.headers
  }
}

@Component
class DialogHandler extends BaseClass {
  search = '';
  timeRules = (v: string) =>
    /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])~(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/.test(v);
  maxchars = (v: string) => v.length <= 10 || 'Input too long!';

  snack = false;
  snackColor = '';
  snackText = '';

  inputCheck(x: EditDialogTimeProps) {
    x.valid = this.timeRules(x.time);
    x.latestTime = x.time;
  }
  onEditDialogSave(x: EditDialogTimeProps) {
    x.saved = true;
    x.valid = this.timeRules(x.time);
  }
  onEditDialogCancel(x: EditDialogTimeProps) {
    x.canceled = true;
  }
  onEditDialogOpen(x: EditDialogTimeProps) {
    x.initTime = x.time;
    x.latestTime = x.time;
  }
  onEditDialogClose(x: EditDialogTimeProps) {
    if (!x.valid || x.canceled) {
      x.time = x.initTime;
      x.canceled = false;
      return;
    }

    if (x.saved) {
      x.time = x.latestTime;
      return;
    }
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      this.panel.items = this.pageInfo.filter(x => x.zoneCode === group.code);
    }
  }

  onListItemChanged(item?: Item) {
    if (item) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;

      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.etc = item.etc;
      this.dataItem.state.operCode = item.operCode ? item.operCode.toString() : '1';
      for (const idx in this.dataItem.state.scheduleTable) {
        const line = this.dataItem.state.scheduleTable[idx];
        const schedule = item.listSchedule[idx];
        if (schedule) {
          const hourStart = schedule.hourFrom.toString().padStart(2, '0');
          const minStart = schedule.minuteFrom.toString().padStart(2, '0');
          const startTime = hourStart + ':' + minStart;

          const hourEnd = schedule.hourTo.toString().padStart(2, '0');
          const minEnd = schedule.minuteTo.toString().padStart(2, '0');
          const endTime = hourEnd + ':' + minEnd;

          const time = startTime + '~' + endTime;
          line.time = time;
          line.sunday = schedule.sunday;
          line.monday = schedule.monday;
          line.tueday = schedule.tuesday;
          line.wedday = schedule.wednesday;
          line.thuday = schedule.thursday;
          line.friday = schedule.friday;
          line.satday = schedule.saturday;
          line.holiday = schedule.holiday;
          line.operfunccode = schedule.operFuncCode ? schedule.operFuncCode.toString() : '1';
        } else {
          line.time = '00:00~00:00';
          line.sunday = false;
          line.monday = false;
          line.tueday = false;
          line.wedday = false;
          line.thuday = false;
          line.friday = false;
          line.satday = false;
          line.holiday = false;
          line.operfunccode = '1';
        }
      }

      this.dataItem.store.setItems(this.dataItem.state.scheduleTable);
    } else {
      this.dataItem.state = new State();
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.itemStatus = E.ItemStatus.New;

    this.dataItem.state.scheduleTable.forEach(item => {
      item.num = 0;
      item.time = '00:00~00:00';
      item.sunday = false;
      item.monday = false;
      item.tueday = false;
      item.wedday = false;
      item.thuday = false;
      item.friday = false;
      item.satday = false;
      item.holiday = false;
    });

    this.dataItem.store.setItems(this.dataItem.state.scheduleTable);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  pageInfo = {} as PageInfo;
  currentSchedule: I.ScheduleDataEx[] = [];

  listOperType: OperCodeType[] = [
    { operCode: '1', name: '출입문 제어' },
    { operCode: '2', name: '안티패스 백' },
    { operCode: '3', name: '센서 제어' },
    { operCode: '4', name: '핀 제어' },
    { operCode: '5', name: '엘리베이터' },
    { operCode: '6', name: '아웃풋 제어' }
  ];
  listDoorOperType: OperCodeType[] = [
    { operCode: '1', name: '개방' },
    { operCode: '2', name: '폐쇄' }
  ];
}

const Handlers = Mixins(ApiHandler, DataItemHandler, DialogHandler, GroupPanelHandler);

@Component
export default class ConfigSchedule extends Mixins(BaseData, Handlers) {
  async prepare() {
    const baseData = await this.getPageInfo();
    if (baseData) {
      this.pageInfo = baseData;
      this.panel.groups = this.getZoneList();
      this.dataItem.store.items = this.dataItem.state.scheduleTable;
    }
  }

  async onSaveClicked() {
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const { code, name, etc, zoneCode, operCode } = this.dataItem.state;

    if (name.length === 0) {
      await this.showErrorModal('오류', '이름을 입력하세요');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    const listSchedule: I.ScheduleDataEx[] = [];
    for (const idx in this.dataItem.state.scheduleTable) {
      const line = this.dataItem.state.scheduleTable[idx];
      const ex = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])~(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/.exec(
        line.time
      );
      if (!ex) {
        return;
      }
      const [, hourFrom, minuteFrom, hourTo, minuteTo] = Array.from(ex).map(x =>
        Number.parseInt(x)
      );

      console.log('line*', hourFrom, minuteFrom, hourTo, minuteTo);
      const schedule: I.ScheduleDataEx = {
        applyBitMask: 0,
        name: this.dataItem.state.name,
        zoneCode: this.dataItem.state.zoneCode,
        etc: this.dataItem.state.etc,
        code: this.dataItem.state.code,
        hourFrom,
        hourTo,
        minuteFrom,
        minuteTo,
        sunday: line.sunday,
        monday: line.monday,
        tuesday: line.tueday,
        wednesday: line.wedday,
        thursday: line.thuday,
        friday: line.friday,
        saturday: line.satday,
        holiday: line.holiday,
        operFuncCode: line.operfunccode ? line.operfunccode.toString() : '0'
      };
      listSchedule.push(schedule);
    }
    console.log(listSchedule);
    this.setLoading(true);
    const result = await this.updateItem({
      code,
      name,
      etc,
      updateFlag,
      operCode,
      zoneCode,
      listSchedule
    });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, updateFlag);
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  async onDeleteClicked() {
    const { code, name, etc, zoneCode, itemStatus, operCode } = this.dataItem.state;

    if (itemStatus === E.ItemStatus.None) return;
    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    const listSchedule: I.ScheduleDataEx[] = [];

    this.setLoading(true);
    const result = await this.updateItem({
      code,
      name,
      etc,
      updateFlag,
      operCode,
      zoneCode,
      listSchedule
    });

    this.setLoading(false);
    if (!result) return;
    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item[], updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;

    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();

    this.panel.group = prevGroup;
    await this.$nextTick();

    if (updateFlag !== E.EUpdateFlag.Delete) {
      if (result.length > 0)
        this.panel.item = this.panel.items.findIndex(x => x.code === result[0].code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }
}
